export default "__VITE_ASSET__12981321__"